import { useNavigate } from "react-router-dom"
import { setNewConversationSearchSource } from "../../../../store/messagingSlice"
import { addPageAction } from "../../../../utils/newrelic"

export const GeneralViewModel = ({
    dispatch,
}: GeneralViewModel): ThreadListViewModel => {
    const navigate = useNavigate()
    const handleUserClick = () => {
        navigate("/search-users")
        dispatch(setNewConversationSearchSource("button"))
        addPageAction("DmNewConversationUserSearch", {
            actionType: "init",
            source: "button",
        })
    }

    return {
        handleUserClick,
    }
}
